// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__Lj2EG","join":"style_join__JlWQK","join__logo":"style_join__logo__l8DQe"};